import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["videos"],
  _excluded2 = ["next", "previous"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Carousel from 'react-multi-carousel';
import { getVideoId } from '@app/helpers';
import { useUser } from '@app/helpers/hooks';
import VideoPreview from '@app/components/molecules/VideoPreview';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Image from '../../../atoms/Image';
import { SliderContainer, VideoContainer, StyledLeftButton, StyledRightButton } from './style';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024
    },
    items: 3,
    slidesToSlide: 1,
    removeArrowOnDeviceType: true // optional, default to 1.
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 600
    },
    items: 3,
    slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: {
      max: 600,
      min: 0
    },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};

// eslint-disable-next-line react/prop-types
var VideoSlider = function VideoSlider(_ref) {
  var videos = _ref.videos,
    props = _objectWithoutProperties(_ref, _excluded);
  var getVideoThumb = function getVideoThumb(videoId) {
    return "https://img.youtube.com/vi/".concat(videoId.value, "/default.jpg");
  };
  var _React$useState = React.useState(videos[0]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    videoPresent = _React$useState2[0],
    setVideoPresent = _React$useState2[1];
  var _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    activeVideo = _React$useState4[0],
    setActiveVideo = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isMobile = _React$useState6[0],
    setIsMobile = _React$useState6[1];
  var arr = [];
  videos.forEach(function (item) {
    var videoId = getVideoId(item);
    arr.push(getVideoThumb(videoId));
  });
  React.useEffect(function () {
    if (window.innerWidth < 600) {
      setIsMobile(true);
    }
  }, []);
  var ButtonGroup = function ButtonGroup(_ref2) {
    var next = _ref2.next,
      previous = _ref2.previous,
      rest = _objectWithoutProperties(_ref2, _excluded2);
    var currentSlide = rest.carouselState.currentSlide;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [' ', /*#__PURE__*/_jsx(StyledLeftButton, {
        onClick: function onClick() {
          return previous();
        },
        children: /*#__PURE__*/_jsx(ChevronLeftIcon, {
          fontSize: "small",
          color: "primary"
        })
      }), /*#__PURE__*/_jsx(StyledRightButton, {
        onClick: function onClick() {
          return next();
        },
        children: /*#__PURE__*/_jsx(ChevronRightIcon, {
          fontSize: "small",
          color: "primary"
        })
      })]
    });
  };
  ButtonGroup.defaultProps = {
    next: function next() {},
    previous: function previous() {}
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(VideoContainer, {
      children: /*#__PURE__*/_jsx(VideoPreview, {
        id: videoPresent,
        value: videoPresent
      })
    }), /*#__PURE__*/_jsx(SliderContainer, {
      children: /*#__PURE__*/_jsx(Carousel, _objectSpread(_objectSpread({
        swipeable: isMobile,
        draggable: false,
        showDots: false,
        responsive: responsive,
        keyBoardControl: true,
        transitionDuration: 500,
        containerClass: "carousel-container",
        removeArrowOnDeviceType: ['tablet', 'mobile'],
        dotListClass: "custom-dot-list-style",
        itemClass: "carousel-item-padding-40-px",
        arrows: false,
        customButtonGroup: /*#__PURE__*/_jsx(ButtonGroup, {})
      }, props), {}, {
        children: arr && arr.map(function (video, index) {
          return /*#__PURE__*/_jsx(Image, {
            className: index === activeVideo && 'active',
            onClick: function onClick() {
              setVideoPresent(videos[index]);
              setActiveVideo(index);
            },
            src: video,
            alt: ""
          });
        })
      }))
    })]
  });
};
VideoSlider.defaultProps = {};
export default VideoSlider;